<div class="page-header">
  <app-page-title></app-page-title>
</div>
<div class="user-profile-container">
  <div class="profile-avatar-card">
    <div class="profile-avatar-wrap">
      @if (displayAvatarUrl) {
        <img [src]="displayAvatarUrl" alt="รูปโปรไฟล์" class="profile-avatar-img">
      } @else {
        <span class="profile-avatar-placeholder"><i class="bi bi-person-fill"></i></span>
      }
      @if (avatarUploading) {
        <div class="profile-avatar-overlay"><span class="spinner-border spinner-border-sm text-light"></span></div>
      }
      <label class="profile-avatar-edit-btn" for="profile-avatar-upload" title="เปลี่ยนรูปโปรไฟล์">
        <i class="bi bi-camera-fill"></i>
      </label>
    </div>
    <input type="file" id="profile-avatar-upload" accept="image/*" class="d-none" (change)="onAvatarFileChange($event)">
    <div class="profile-avatar-info">
      <strong>{{ currentUserProfile()?.fullName || "—" }}</strong>
      <span>{{ currentUserProfile()?.email || "" }}</span>
      <small>คลิกที่รูปเพื่อเปลี่ยนรูปโปรไฟล์ (ไม่เกิน 4MB)</small>
    </div>
    <button type="button" class="btn-edit-profile" (click)="redirectToPortalProfile()">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" height="16" width="16"
           stroke-linecap="round" stroke-linejoin="round">
        <path d="M12 20h9"></path>
        <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z"></path>
      </svg>
      <span>แก้ไขข้อมูล</span>
    </button>
  </div>
  <app-account-switcher *hasAnyRole="['AGENT_OPERATOR']"></app-account-switcher>
  <div class="view-data-card personal-info-card">
    <div class="view-card-header">
      <div class="view-card-icon"><i class="bi bi-person"></i></div>
      <span class="view-card-title">ข้อมูลส่วนตัว</span>
    </div>
    <div class="view-card-rows">
      <div class="view-row">
        <span class="view-label">รหัสอ้างอิง</span>
        <span class="view-value d-flex align-items-center gap-2">
          <span>{{ currentUserProfile()?.referenceCode || "—" }}</span>
          <button type="button" class="btn btn-sm btn-outline-secondary py-0"
                  [disabled]="!currentUserProfile()?.referenceCode"
                  (click)="copyCode(currentUserProfile()?.referenceCode || '')"
                  title="คัดลอก">
            <i class="bi bi-copy"></i>
          </button>
        </span>
      </div>
      <div class="view-row">
        <span class="view-label">ประเภทผู้ใช้</span>
        <span class="view-value">{{ userRoleSummary }}</span>
      </div>
      <div class="view-row">
        <span class="view-label">ชื่อ-นามสกุล</span>
        <span class="view-value">{{ thaiName }}</span>
      </div>
      <div class="view-row">
        <span class="view-label">ชื่อ-นามสกุล (Eng)</span>
        <span class="view-value">{{ englishName }}</span>
      </div>
      <div class="view-row">
        <span class="view-label">วันเดือนปีเกิด</span>
        <span class="view-value">{{ (currentUserProfile()?.birthdate | thaidatetime: {showTime: false}) || "—" }}</span>
      </div>
      <div class="view-row">
        <span class="view-label">ประเภทบัตร</span>
        <span class="view-value">{{ cardTypeLabel }}</span>
      </div>
      <div class="view-row">
        <span class="view-label">เลขบัตร</span>
        <span class="view-value">{{ currentUserProfile()?.cardNo || "—" }}</span>
      </div>
    </div>

    <div class="view-card-header border-top">
      <div class="view-card-icon"><i class="bi bi-geo-alt"></i></div>
      <span class="view-card-title">ข้อมูลการติดต่อ</span>
    </div>
    <div class="view-card-rows">
      <div class="view-row">
        <span class="view-label">ที่อยู่</span>
        <span class="view-value">{{ fullAddress() }}</span>
      </div>
      <div class="view-row">
        <span class="view-label">มือถือ</span>
        <span class="view-value">{{ currentUserProfile()?.mobile || "—" }}</span>
      </div>
      <div class="view-row">
        <span class="view-label">โทรศัพท์</span>
        <span class="view-value">{{ currentUserProfile()?.phoneNo || "—" }}</span>
      </div>
      <div class="view-row">
        <span class="view-label">โทรสาร</span>
        <span class="view-value">{{ currentUserProfile()?.faxNo || "—" }}</span>
      </div>
      <div class="view-row">
        <span class="view-label">อีเมล</span>
        <span class="view-value">{{ currentUserProfile()?.email || "—" }}</span>
      </div>
    </div>
  </div>
</div>
